import { IState } from '../../../store';
import { IUndergroundInfo } from '../../../types/geo/underground';

export function undergroundsSelector(state: IState): IUndergroundInfo[] | null {
  return state.offerData.offer.geo.undergrounds;
}
